import { render, staticRenderFns } from "./heart.vue?vue&type=template&id=ca448c14&scoped=true&"
import script from "./heart.vue?vue&type=script&lang=js&"
export * from "./heart.vue?vue&type=script&lang=js&"
import style0 from "./heart.vue?vue&type=style&index=0&id=ca448c14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca448c14",
  null
  
)

export default component.exports